// src/components/DeleteAccountSheet.jsx
//
// «Удалить аккаунт» (требование Google Play). Только сам владелец учётки, с паролем.
// Покупатель обезличивается сразу; магазин закрывается сразу, данные удаляются
// в течение 30 дней (см. POST /auth/delete-account и public/privacy.html).

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { auth as authApi } from '../api';
import Icon from './Icon';
import PasswordInput from './PasswordInput';

export function DeleteAccountLink({ onClick }) {
  const { t } = useTranslation();
  return (
    <button
      onClick={onClick}
      style={{
        display: 'block', margin: '4px auto 0', padding: '10px 12px',
        background: 'none', border: 'none', cursor: 'pointer',
        fontSize: 13, color: 'var(--fg-muted)', textDecoration: 'underline',
      }}
    >
      {t('account.delete')}
    </button>
  );
}

export default function DeleteAccountSheet({ isShop, onDeleted, onClose }) {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async () => {
    if (!password || busy) return;
    setBusy(true); setErr('');
    try {
      await authApi.deleteAccount(password);
      onDeleted();
    } catch (e) {
      setErr(e.message || t('common.error'));
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && !busy && onClose()}>
      <div className="modal-sheet" style={{ maxWidth: 520, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <p style={{ flex: 1, fontSize: 18, fontWeight: 800, fontFamily: 'var(--font-display)', color: 'var(--danger)' }}>
            {t('account.deleteTitle')}
          </p>
          <button className="modal-close" onClick={onClose} disabled={busy}><Icon name="x" size={16} /></button>
        </div>

        <p style={{ fontSize: 14, lineHeight: 1.5, marginBottom: 10 }}>
          {isShop ? t('account.deleteShopText') : t('account.deleteCustomerText')}
        </p>
        <p style={{ fontSize: 13, lineHeight: 1.45, color: 'var(--fg-muted)', marginBottom: 14 }}>
          {t('account.deletePasswordHint')}
        </p>

        <PasswordInput
          value={password}
          onChange={e => { setPassword(e.target.value); setErr(''); }}
          onKeyDown={e => e.key === 'Enter' && submit()}
          placeholder={t('account.password')}
          autoComplete="current-password"
        />
        {err && <p style={{ fontSize: 13, color: 'var(--danger)', marginTop: 8 }}>{err}</p>}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16, paddingBottom: 'env(safe-area-inset-bottom)' }}>
          <button
            className="btn btn-lg"
            onClick={submit}
            disabled={!password || busy}
            style={{ background: 'var(--danger)', color: '#fff', border: 'none' }}
          >
            {busy ? t('common.loading') : t('account.deleteConfirm')}
          </button>
          <button className="btn btn-secondary" onClick={onClose} disabled={busy}>{t('common.cancel')}</button>
        </div>
      </div>
    </div>
  );
}
